import { useMemo } from "react";
import { useAllSentimentHistory, useAllStaffToneFlags, useGroups } from "./api";
import { useDemoIdentity } from "./DemoIdentityContext";
import { nb } from "./journey";
import { buildEscalations } from "./queueMetrics";

// What the shell shows about the cars this login is looking at: the rail's badge
// and the drawer's "N cars in service".
export function useMsdScope() {
  const { scopeLocations } = useDemoIdentity();
  const { data: groupsData } = useGroups();
  const { data: sentiment } = useAllSentimentHistory();
  const { data: tone } = useAllStaffToneFlags();

  return useMemo(() => {
    const rows = groupsData?.rows || [];
    const inScope = scopeLocations === "all" ? rows : rows.filter((g) => scopeLocations.includes(g["Workshop Location"]));
    // In service = a car that has not been handed back yet.
    const groups = inScope.filter((g) => !nb(g["Delivery Notified"]));
    const escalatedCount = buildEscalations(inScope, sentiment?.rows || [], tone?.rows || []).filter(
      (e) => e.status === "open"
    ).length;
    const scopeLabel =
      scopeLocations === "all" ? "All workshops" : scopeLocations.length ? scopeLocations.join(", ") : "No location";
    return { groups, escalatedCount, scopeLabel };
  }, [groupsData, sentiment, tone, scopeLocations]);
}
